/**
 * RDT infringement types.
 *
 * @readonly
 * @enum {string}
 */
export const RdtInfringementTypes = Object.freeze({
    DAILY_DRIVING_TIME_EXCEEDED: 'DAILY_DRIVING_TIME_EXCEEDED',
    WEEKLY_DRIVING_TIME_EXCEEDED: 'WEEKLY_DRIVING_TIME_EXCEEDED',
    FORTNIGHTLY_DRIVING_TIME_EXCEEDED: 'FORTNIGHTLY_DRIVING_TIME_EXCEEDED',
    DRIVING_PERIOD_EXCEEDED: 'DRIVING_PERIOD_EXCEEDED',
    DAILY_REST_TOO_SHORT: 'DAILY_REST_TOO_SHORT',
    REDUCED_DAILY_REST_TOO_SHORT: 'REDUCED_DAILY_REST_TOO_SHORT',
    MULTI_MANNING_DAILY_REST_TOO_SHORT: 'MULTI_MANNING_DAILY_REST_TOO_SHORT',
    WEEKLY_REST_TOO_SHORT: 'WEEKLY_REST_TOO_SHORT',
    REDUCED_WEEKLY_REST_TOO_SHORT: 'REDUCED_WEEKLY_REST_TOO_SHORT',
    DRIVEN_BEYOND_DAILY_ON_DUTY_PERIOD: 'DRIVEN_BEYOND_DAILY_ON_DUTY_PERIOD',
    DRIVEN_BEYOND_WEEKLY_ON_DUTY_LIMIT: 'DRIVEN_BEYOND_WEEKLY_ON_DUTY_LIMIT',
    BREAK_TIME_TOO_SHORT: 'BREAK_TIME_TOO_SHORT',
    WEEKLY_REST_STARTED_TOO_LATE: 'WEEKLY_REST_STARTED_TOO_LATE'
})
